import { Component, Input, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton';
import { SkeletorConfTemplateComponent } from './variants/conf.template.component';
import { SkeletorClasifTemplateComponent } from './variants/clasif.template.component';
import { SkeletorCardTemplateComponent } from './variants/card.template.component';
import { SkeletorListTemplateComponent } from './variants/list.template.component';
import { SkeletorTableTemplateComponent } from './variants/table.template.component';
import { SkeletorRequestDataTemplateComponent } from './variants/request-data.template.component';
import { SkeletorDocumentRequirementsTemplateComponent } from './variants/document-requirements.template.component';
import { SkeletorTypeSheetsTemplateComponent } from './variants/type-sheets.template.component';
import { SkeletorSociosNegocioTemplateComponent } from './variants/socios-negocio.template.component';
import { SkeletorPartnerDetailTemplateComponent } from './variants/partner-detail.template.component';
import { SkeletorBaseHomeTemplateComponent } from './variants/base-home.template.component';
import { SkeletorCreateSupplierTemplateComponent } from './variants/create-supplier.template.component';

@Component({
  selector: 'app-skeletor',
  standalone: true,
  imports: [CommonModule, NgIf, NgFor, SkeletonModule, SkeletorConfTemplateComponent, SkeletorClasifTemplateComponent, SkeletorCardTemplateComponent, SkeletorListTemplateComponent, SkeletorTableTemplateComponent, SkeletorRequestDataTemplateComponent, SkeletorDocumentRequirementsTemplateComponent, SkeletorTypeSheetsTemplateComponent, SkeletorSociosNegocioTemplateComponent, SkeletorPartnerDetailTemplateComponent, SkeletorBaseHomeTemplateComponent, SkeletorCreateSupplierTemplateComponent],
  templateUrl: './skeletor.component.html',
  styleUrl: './skeletor.component.scss'
})
export class SkeletorComponent implements OnChanges, OnDestroy {
  @Input() loading: boolean = false;
  @Input() variant: 'text' | 'conf' | 'card' | 'list' | 'table' | 'clasif' | 'request-data' | 'document-requirements' | 'type-sheets' | 'socios-negocio' | 'partner-detail' | 'base-home' | 'create-supplier' = 'text';
  @Input() items: number = 5;
  @Input() delayMs: number = 2000;

  show = false;
  private startTs = 0;
  private hideTimer: any;

  get rows(): any[] {
    return Array.from({ length: this.items });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('loading' in changes) {
      if (this.loading) {
        this.startTs = Date.now();
        this.show = true;
        if (this.hideTimer) {
          clearTimeout(this.hideTimer);
          this.hideTimer = null;
        }
      } else {
        const elapsed = Date.now() - this.startTs;
        const remaining = Math.max(0, this.delayMs - elapsed);
        if (remaining === 0) {
          this.show = false;
        } else {
          this.hideTimer = setTimeout(() => {
            this.show = false;
            this.hideTimer = null;
          }, remaining);
        }
      }
    }
  }

  ngOnDestroy(): void {
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
    }
  }
}
